module.exports = __webpack_public_path__ + "img/conectividad.e121b1ad.png";